import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  ShippingContactConfigurationDto,
  ShippingContactConfigurationModel,
  ShippingContactConfigurationResp,
  ShippingContactValidationDto,
  ShippingContactValidationModel,
} from '../types/shipping-contact'

const transformShippingContactValidationDto = (
  dto: ShippingContactValidationDto,
): ShippingContactValidationModel => ({
  regex: dto.regex,
  message: dto.message,
  trackingTarget: dto.tracking_target,
})

export const transformShippingContactConfigurationDto = (
  dto: ShippingContactConfigurationDto,
): ShippingContactConfigurationModel => ({
  phoneNumber: {
    validations: dto.phone_number?.validations.map(transformShippingContactValidationDto) || [],
  },
})

export const transformShippingContactConfigurationResp = (
  response: Response<ShippingContactConfigurationResp>,
) => transformShippingContactConfigurationDto(response.shipping_contact_configuration)
